import BomTable from './BomTable';

export default BomTable;
